import styled from 'styled-components';

import { ErrorSpan } from '../commons/styles';

import Input from '../commons/component/input';

export const InputWithAddon = styled(Input)`
  padding-right: 40px;
`;

export const Addon = styled.a`
  height: 27px;
  width: 27px;
  color: #b8b8b8;
  cursor: pointer;
  position: absolute;
  top: 50%;
  margin-top: -13.5px;
  right: 7px;

  @media (max-width: 800px) {
    right: 7px;
    bottom: 7px;
  }
`;

export const InputUpperLink = styled.a`
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 5px;
  cursor: pointer;
`;

export const LeftErrorSpan = styled(ErrorSpan)`
  margin-left: 0px;
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const SignUpContainer = styled.p`
  text-align: center;
  margin-top: 2rem;

  @media (max-width: 800px) {
    margin: 2rem -15px 0;
    padding-top: 2rem;
    border-top: 2px solid #eee;
  }
`;

export const PrivacyPolicy = styled.p`
  color: #666;
  text-align: center;
  font-size: 1.4rem;

  > a {
    display: inline-block;
  }
`;
